import { getHostName } from "../api-services/axiosClient";

export const navigateToDomainWithLocalStorageData = (
  domain,
  localStorageData,
  isBackoffice = true
) => {
  const isDevelopmentEnv =
    process.env.ACTIVE_ENV === "development" || process.env.NODE_ENV === "development";
  const subdomainURL = `${isDevelopmentEnv ? "http" : "https"}://${domain ? `${domain}.` : ""}${
    isBackoffice ? "backoffice" : "app"
  }.${getHostName()}${isDevelopmentEnv ? `${isBackoffice ? ":8000" : ":8001"}` : ""}${
    localStorageData && `/?data=${encodeURIComponent(JSON.stringify(localStorageData))}`
  }`;
  // Maintaining authentication information

  window.location.href = subdomainURL;
  localStorage.clear();
};
